function normalizeOrigin(raw: string | undefined): string {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return '';
  return trimmed.replace(/\/+$/, '');
}

const DEFAULT_API_ORIGIN =
  normalizeOrigin(process.env.REACT_APP_API_URL) || 'https://api-balony.techcrowd.space';

export const APP_ORIGIN = normalizeOrigin(process.env.REACT_APP_APP_URL);

const API_ORIGIN_OVERRIDE_KEY = 'balony.apiOriginOverride';

function allowRuntimeOverride(): boolean {
  return String(process.env.REACT_APP_ALLOW_API_OVERRIDE).toLowerCase() === 'true';
}

export function getApiOrigin(): string {
  if (!allowRuntimeOverride()) return DEFAULT_API_ORIGIN;
  if (typeof window === 'undefined') return DEFAULT_API_ORIGIN;

  const override = normalizeOrigin(window.localStorage.getItem(API_ORIGIN_OVERRIDE_KEY) ?? undefined);
  return override || DEFAULT_API_ORIGIN;
}

export function setApiOriginOverride(origin: string | null): void {
  if (typeof window === 'undefined') return;
  if (!allowRuntimeOverride()) return;

  const normalized = origin ? normalizeOrigin(origin) : '';
  if (!normalized) {
    window.localStorage.removeItem(API_ORIGIN_OVERRIDE_KEY);
    return;
  }
  window.localStorage.setItem(API_ORIGIN_OVERRIDE_KEY, normalized);
}

export function getDefaultApiOrigin(): string {
  return DEFAULT_API_ORIGIN;
}

export function apiUrl(pathname: string): string {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${getApiOrigin()}/api${path}`;
}

export function assetUrl(pathname: string): string {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${getApiOrigin()}${path}`;
}
